"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getConfig = function () {
    return {
        "apiKey": "AIzaSyAl6dAbeGAjzJ5HwwaVB6ie9BqzDlxcDh4",
        "authDomain": "try.metricsquare.com",
        "databaseURL": "https://bipath2.firebaseio.com",
        "messagingSenderId": "596364147787",
        "projectId": "bipath2",
        "storageBucket": "bipath2.appspot.com"
    };
};
exports.default = getConfig;
//# sourceMappingURL=FirebaseConfig.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/data/FirebaseConfig.js
// module id = 617
// module chunks = 8